
import { animate, style, transition, trigger } from '@angular/animations';

export const accordionAnimation = trigger('accordionAnimation', [
  transition(':enter', [
    style({ height: 0, overflow: 'hidden' }),
    animate('300ms ease-out', style({ height: '*' }))
  ]),
  transition(':leave', [
    style({ height: '*', overflow: 'hidden' }),
    animate('300ms ease-in', style({ height: 0 }))
  ])
]);
/**
 * In-app push toast (see Shared/notification-toast) -- slides in from the right edge of the
 * screen and slides back out the same way, per Mihir's spec ("like how toasters appear from
 * right screen and then goes back to right screen"). Distinct from ngx-toastr (already used
 * elsewhere in the app for warning/success banners) because ngx-toastr's built-in animation is
 * an opacity fade, not a translateX slide, and this needed a look that matches the notification
 * bell's own card styling plus custom aggregation ("5 new notifications") that a generic toast
 * library isn't set up for.
 */
export const toastSlideAnimation = trigger('toastSlideAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(120%) scale(0.92)', opacity: 0 }),
    // A slight overshoot ("back" easing) on the way in makes the toast feel like it's actively
    // announcing itself rather than just fading up -- more attention-grabbing than a plain ease.
    animate('440ms cubic-bezier(0.34, 1.56, 0.64, 1)', style({ transform: 'translateX(0) scale(1)', opacity: 1 }))
  ]),
  transition(':leave', [
    animate('260ms cubic-bezier(0.4, 0, 1, 1)', style({ transform: 'translateX(120%) scale(0.96)', opacity: 0 }))
  ])
]);
